module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/dusting-39b2ad65858dcb057352c6f6dffa7bc5.svg";